import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTag = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_27_6105)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M11.6667 3.3335C12.219 3.3335 12.6667 3.78121 12.6667 4.3335C12.6667 4.88578 12.219 5.3335 11.6667 5.3335C11.1144 5.3335 10.6667 4.88578 10.6667 4.3335C10.6667 3.78121 11.1144 3.3335 11.6667 3.3335Z",
				stroke: "#ADB5BD",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.84947 7.42928C1.1807 8.17621 1.16632 9.30308 1.78009 10.0958C2.99806 11.6689 4.33114 13.0019 5.9042 14.2199C6.69692 14.8337 7.82378 14.8193 8.57072 14.1505C10.5986 12.3348 12.4556 10.4373 14.2479 8.35194C14.4251 8.14581 14.5359 7.89314 14.5608 7.62241C14.6708 6.42533 14.8968 2.97646 13.9602 2.03984C13.0235 1.10322 9.57465 1.32919 8.37758 1.43918C8.10685 1.46406 7.85418 1.5749 7.64798 1.75208C5.56273 3.54432 3.66519 5.40142 1.84947 7.42928Z",
				stroke: "#ADB5BD",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.66669 9.33347L6.66667 11.3335",
				stroke: "#ADB5BD",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_27_6105",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
export default SvgTag;
